export default __webpack_public_path__ + "static/media/isabella1.60f31a15.png";